import { Auth } from 'aws-amplify';
import React, { useEffect, useRef, useState } from 'react';
import httpRequestHandler from '../utils/helpers/httpRequestHandler';
import signOutHandler from '../utils/helpers/signOutHandler';
import { FUNDING_SOURCE } from '../utils/constants/enum.ts';
const UserContext = React.createContext({
    userData: null,
    uiSecret: null,
    setUserDataHandler: (userData) => {},
});

export const UserContextProvider = (props) => {
    const [userData, setUserData] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [agencyPreference, setAgencyPreference] = useState(false);
    const [uiSecret, setUiSecret] = useState(null);
    const [isUpskillOnlyUserLoggedIn, setIsUpskillOnlyUserLoggedIn] = useState(false);
    const [showDemographicNote, setShowDemographicNote] = useState(false);
    const bootstrapStartedRef = useRef(false);
    const uiSecretRef = useRef(uiSecret);
    uiSecretRef.current = uiSecret;
    useEffect(() => {
        if (bootstrapStartedRef.current) {
            return;
        }
        bootstrapStartedRef.current = true;
        Auth.currentAuthenticatedUser()
            .then(async (user) => {
                if (user) {
                    if (!user.attributes.email_verified) {
                        setUserData(null);
                        signOutHandler();
                    } else {
                        setIsLoggedIn(true);
                        const res = await httpRequestHandler('/getcasemanagerbyemailid', 'post', {
                            email: user.attributes.email,
                        });
                        const upskillGroups = [FUNDING_SOURCE.UpSkill_OC_CalOptima, FUNDING_SOURCE.Upskill_OC_Department_of_Veteran_Affairs, FUNDING_SOURCE.Upskill_OC_OYACPP_EDD];
                        
                        const fundingSourceCodes = Array.isArray(res[0].FundingSourceCodes)
                            ? res[0].FundingSourceCodes
                            : typeof res[0].FundingSourceCodes === 'string'
                                ? res[0].FundingSourceCodes.split(',').map(x => x.trim())
                                : [];
                        
                        // set flag for UpSkill user
                        const isUpskillOnlyUserLoggedIn = fundingSourceCodes.length > 0 &&
                            fundingSourceCodes.every(group => upskillGroups.includes(group));

                        setIsUpskillOnlyUserLoggedIn(isUpskillOnlyUserLoggedIn);
                        setUserData(res[0]);

                        if (!isUpskillOnlyUserLoggedIn) {
                            setShowDemographicNote(res[0]?.HasOldDemographicClients === true);
                        }
                    }
                    if(uiSecretRef.current == null)
                    {
                        const res1 = await httpRequestHandler('/getuisettings', 'get');
                        setUiSecret(res1);
                    }
                }
            })
            .catch((e) => {
                console.log(e);
                setIsLoggedIn(false);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const setUserDataHandler = (userData) => {
        setUserData(userData);
    };

    const setAgencyPreferenceHandler = (value) => {
        setAgencyPreference(value);
    };

    const setUiSecretHandler = (uiSecret) => {
        setUiSecret(uiSecret);
    };

    const contextValue = {
        isLoggedIn: isLoggedIn,
        userData,
        agencyPreference,
        setAgencyPreferenceHandler,
        setUserDataHandler,
        uiSecret,
        setUiSecretHandler,
        isUpskillOnlyUserLoggedIn,
        showDemographicNote,
        setShowDemographicNote,
    };

    if (isLoading) {
        return
    }

    return <UserContext.Provider value={contextValue}>{props.children}</UserContext.Provider>;
};

export default UserContext;
